import { CustomDialog } from "../../../global/components";
import subscriptionStyles from "../Subscriptions.styles";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import history from "../../../utils/history";
import urls from "../../../global/constants/UrlConstants";
import { useTranslation } from "react-i18next";

interface CustomProps {
  setIsLoading: Function;
  handleClose: Function;
  open: boolean;
}

const ChangePlanDialog = (props: CustomProps) => {
  const classes = subscriptionStyles;
  const { t } = useTranslation();

  const dialogHeaderContent = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2} pt={5}>
        <Typography sx={classes.modalHeader} px={2}>
          {t("changePlanHeader")}
        </Typography>

        <Divider
          sx={{
            border: "1px solid #222222",
            width: "50%",
            height: "0px",
          }}
        />
      </Stack>
    );
  };

  const dialogBodyContent = () => {
    return (
      <Stack direction={"column"} pb={5} spacing={2} sx={classes.dialogContent}>
        <Typography sx={classes.darkFont} py={2}>
          {t("changePlanContent")}
        </Typography>
        <Stack
          direction={{ sm: "row", xs: "column" }}
          spacing={2}
          alignSelf={"center"}
        >
          <Button onClick={() => props.handleClose()} sx={classes.cancelBtn}>
            <Box sx={classes.cancelBtnBox}>
              <Typography className="btnText">{t("no")}</Typography>
            </Box>
          </Button>
          <Button
            onClick={() => history.push(`${urls.pricingViewPath}?change=true`)}
            sx={classes.logoutBtn}
          >
            <Typography className="btnText">{t("yes")}</Typography>
          </Button>
        </Stack>
      </Stack>
    );
  };
  const getChangePlanDialog = () => {
    return (
      <CustomDialog
        width="600px"
        borderRadius="10px"
        isDialogOpen={props.open}
        closable={true}
        closeButtonVisibility={true}
        handleDialogClose={() => props.handleClose()}
        dialogHeaderContent={dialogHeaderContent()}
        dialogBodyContent={dialogBodyContent()}
      />
    );
  };
  return getChangePlanDialog();
};

export default ChangePlanDialog;
